import { useContext } from 'react'
import Mobile from './Mobile'
import Desktop from './Desktop'
import { NavContext } from 'components/Admin/Shared/Menu/Shared/context'
import { useIsLaptopOrAbove } from 'hooks/useMediaQuery'

export default function Menu() {
  const isLaptop = useIsLaptopOrAbove()
  const { navOpen } = useContext(NavContext)
  // TODO: Fix this logic that determines which tabs to display
  return isLaptop ? <Desktop /> : navOpen ? <Mobile /> : null
}
